import { REGISTERED_APPS } from '../../shared/types/Apps';
import { logInfo, logError } from '../../shared/utils/logging';

export function validateFormForCandyCart(
  button: HTMLInputElement,
  app: REGISTERED_APPS = REGISTERED_APPS.CHECKOUT_BUTTON,
) {
  if (window.CANDYCART_DISABLE_FORM_VALIDATION) {
    return true;
  }

  try {
    const form = button.closest('form');
    if (!form) {
      return true;
    }
    const canValidate = form.getAttribute('novalidate') === null;
    if (!canValidate) {
      logInfo('detected novalidate form attribute', app);
      return true;
    }
    logInfo('form.checkValidity()', app, form.checkValidity());
    return form.checkValidity();
  } catch (error) {
    logError(error, app);
    return true;
  }
}
